import { render, staticRenderFns } from "./DisplayContainer.vue?vue&type=template&id=d0ae1dee&scoped=true&"
import script from "./DisplayContainer.vue?vue&type=script&lang=js&"
export * from "./DisplayContainer.vue?vue&type=script&lang=js&"
import style0 from "./DisplayContainer.vue?vue&type=style&index=0&id=d0ae1dee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ae1dee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
